<template>
    <app-layout id="payment_progress">
        <AppHead title="Make Balance Payment" />
        <template #header>
            <h2 class="title">
                Make Payment
                <p v-if="for_user" class="d-inline-block mb-0">
                    On Behalf of <span v-if="for_user.first_name">{{ for_user.first_name }} {{ for_user.last_name }}</span>
                    <span v-else>Customer</span>
                </p>
            </h2>
            <flash-messages />
        </template>

        <section class="py-2">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <card headerStyle="primary" title="Make Payment">
                        <div class="row">
                            <div class="col-12 col-md-6 mb-3 mb-lg-0">
                                <p class="font-weight-bold mb-0">Payment Amount</p>
                                <AmountInput v-model="form.payment_amount"
                                    :inputMin="[isShop ? user.payment_minimum || 0 : '']" />
                            </div>
                            <div class="col-12 col-md-6">
                                <template v-if="user.payment_minimum">
                                    <p class="mb-1 font-weight-bold">Minimum Payment:</p>
                                    <h5 class="text-success">${{ formatCurrency(user.payment_minimum) }}</h5>
                                </template>
                            </div>
                        </div>
                    </card>

                    <BalancePaymentTypes :form="form" :for_user="for_user" :cards="cards" :banks="banks"
                        :form_bank="formBank" :payment_intents="payment_intents" :link_token="link_token" :user="user"
                        @setPaymentMethod="setPaymentMethod" @bankAdded="updateSelected" />

                    <jet-button class="px-5 mt-3" btnStyle="success" :disable="form.processing"
                        @click="completeCheckout()">Submit</jet-button>
                </div>

                <section class="col-12 col-lg-6">
                    <PaymentProgress @updateAmount="updateAmount" :charges="charges" :for_user="for_user" :user="user" />
                </section>
            </div>
        </section>

        <AddCard :routeUrl="route('cart.addCard')" :formCard="formCard" @cardUpdated="updateSelected" />
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import FlashMessages from '@/Shared/FlashMessages'
import JetDialogModal from '@/Jetstream/DialogModal'
import JetDangerButton from '@/Jetstream/DangerButton'

import moment from 'moment'
import toastr from 'toastr'

import AddCard from '@/Components/Modals/AddCard'
import PaymentProgress from '@/Components/Payment/PaymentProgress'
import BalancePaymentTypes from '@/Components/Payment/BalancePaymentTypes'
import AmountInput from '@/Shared/AmountInput'

export default {
    components: {
        AppLayout,
        FlashMessages,
        JetDialogModal,
        JetDangerButton,
        AddCard,
        PaymentProgress,
        BalancePaymentTypes,
        AmountInput
    },
    props: {
        for_user: Object,
        charges: Array,
        cards: Array,
        banks: Array,
        payment_intents: Array,
        payment_intent: String,
        payment_method_id: Number,
        link_token: String,
        user: Object
    },
    data() {
        return {
            form: this.$inertia.form({
                payment_intent: this.payment_intent,
                stripe_payment_method: this.payment_method_id,
                payment_amount: this.user.payment_minimum || null,
                cash_credit_amount: null,
                cash_debit_amount: null,
                check_number: null,
            }),
            formCard: this.$inertia.form({
                user_id: this.user.id,
                card_name: null,
                card_number: null,
                card_exp_month: null,
                card_exp_year: null,
                card_cvc: null,
                card_zip: null,
            }),
            formBank: this.$inertia.form({
                user_id: this.user.id,
                public_token: null,
                account_id: null
            })
        }
    },
    created() {
        this.moment = moment;
    },
    computed: {
        isShop() {
            return this.$page.props.auth.user.role == 'shop'
        }
    },
    methods: {
        setPaymentMethod(e, id) {
            if (e.target.checked) this.form.stripe_payment_method = id;
        },
        updateAmount(val) {
            this.form.payment_amount = val
        },
        completeCheckout() {
            if ((this.form.payment_intent == 'Credit Card' ||
                this.form.payment_intent == 'ACH') &&
                !this.form.stripe_payment_method
            ) {
                toastr.error("Please select a payment method");
            } else {
                this.form.post(this.route('tu.balancepayment.submit', this.user));
            }
        },
        updateSelected() {
            this.form.stripe_payment_method = this.payment_method_id;
        },
    },
}
</script>
